import { clone } from "lodash";

import { Section } from "lib/data/model";

export class ComponentService {

	public static getHierarchyString = (hierarchy: Section[]): string => {

		// Clone Array
		const clonedHierarchy = clone(hierarchy);

		// Build Stringified Hierarchy
		const stringifiedHierarchy = clonedHierarchy.map((i) => {

			// Check For Published Version
			if (i.published === undefined) {

				// Check For Need To Hide Unpublished
				if (i.draft !== undefined) {

					// Return Draft Name
					return i.draft.name;
				}
				else {

					// Return Placeholder Value
					return "[...]";
				}
			}
			else {

				// Return Published Name
				return i.published.name;
			}
		});

		// Return Hierarchy String
		return stringifiedHierarchy.join(" > ");
	}
}
